import "./Contact.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

function Contact() {
  return (
    <div className="contact">
      <Header />
      <div className="contact_body">
        <section className="contact_section_one">
          <h1>Reach Out Today.</h1>
        </section>
        <section className="contact_section_two">
          <div>
            <h1>Research, Engineering & Collaboration</h1>
            <p>
              Open to collaborations in computational physics, radiation
              transport, CFD, and numerical modeling of physical systems.
            </p>
            <h3
              onClick={() =>
                (window.location =
                  "mailto:johnharry238@gmail.com?subject=Research Collaboration Inquiry")
              }
            >
              CONTACT FOR RESEARCH
            </h3>
          </div>
          <div>
            <h1>Academic & Internship Opportunities</h1>
            <p>
              Available for research internships, graduate research positions,
              and academic collaborations in nuclear and energy systems.
            </p>
            <h3
              onClick={() =>
                (window.location =
                  "mailto:johnharry238@gmail.com?subject=Academic Opportunity")
              }
            >
              ACADEMIC INQUIRIES
            </h3>
          </div>
          <div>
            <h1>Professional & Technical Work</h1>
            <p>
              Selectively available for technical consulting and software
              development related to scientific computing and simulation.
            </p>
            <h3
              onClick={() =>
                (window.location =
                  "mailto:johnharry238@gmail.com?subject=Professional Inquiry")
              }
            >
              PROFESSIONAL CONTACT
            </h3>
          </div>
        </section>
        <section className="contact_section_three">
          <h1>Or Get in contact directly</h1>
          <h3
            onClick={() =>
              (window.location =
                "mailto:johnharry238@gmail.com?subject=General Inquiry")
            }
          >
            MAIL Johnharry238@gmail.com
          </h3>
          <a href="tel:+33746511307">
            <h3>Phone: +33 7 46 51 13 07</h3>
          </a>
          <a
            href="https://www.linkedin.com/in/harry-azamosa-525087149"
            target="_blank"
          >
            <h3>SEND A MESSAGE ON Linkedin</h3>
          </a>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
